<template>
    <div class="customer-info mr-6">
        <div class="d-flex mb-5 text-h7">
          <span class="font-weight-600 secondary--font">Customer Info </span>
          <span
            class="float-left pl-1"
            v-if="
              $can('update', 'contacts') &&
              !ticketAccess.closed &&
              !(ticketAccess.contactRemoved || ticketAccess.deleted) 
            "
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="mt-n1 ml-1" size="20px" v-bind="attrs" v-on="on" @click.stop="redirectToContact(ticketDetails.contact_id)">
                  mdi-pencil
                </v-icon>
              </template>
              <span>Update Contact Details</span>
            </v-tooltip>
          </span>
          <template v-if="ticketAccess.contactRemoved || ticketAccess.deleted">
            <div class="mt-n1 ml-1">
              <v-icon size="20px" disabled> mdi-pencil </v-icon>
            </div>
          </template>
        </div>
        <p class="body-2 mb-1 grey--text text--darken-3"> Name </p>
        <div class="text-capitalize subtitle-1">
          <span v-if="ticketDetails.contact_id">
            <router-link :to="{ name: 'contact-dashboard', params: { accountId: account.id, contactId: ticketDetails.contact_id }}" v-track="'contact-dashboard-link'" class="text-decoration-none">
              {{ returnContactName }}
              <v-icon class="pl-1" size="18px" color="#006baf"> mdi-launch</v-icon>
            </router-link>
          </span>
        </div>

        <div class="word-break my-5 mr-6">
          <p class="body-2 mb-1 grey--text text--darken-3"> Email </p>
          <div class="subtitle-1 width-100 text-truncate">{{ ticketDetails.contact_email | upperCaseFirst }}</div>
        </div>
        <div class="mt-1">
          <p class="body-2 mb-1 grey--text text--darken-3"> Mobile no. </p>
          <span class="subtitle-1"> {{ ticketDetails.contact_phone ? ticketDetails.contact_phone : '--' }} </span>
        </div>
      </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ticketMixin } from "@/mixins/ticket";

export default {
  name: "customer-info",
  mixins: [ticketMixin],
  props: {
    ticketDetails: {
      type: Object,
    },
  },
  computed:{
    ...mapGetters({
      account: ["auth/account"],
    }),

    returnContactName(){
      if(this.ticketDetails.contact_name && this.ticketDetails.contact_name !== ' '){
        return this.ticketDetails.contact_name
      }
      else return "--"

    },
   },
  methods: {
    redirectToContact(contactId) {
      this.$router.push({ name: "edit-contact", params: { id: contactId } });
    },
  }
}
</script>